/**
 * Sex / gender values aligned with applicant FormContext + LanguageContext `section2.sexOptions`
 * (male | female | undetermined).
 */

export const APPLICANT_SEX_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'undetermined', label: 'Undetermined' },
];

/** Map stored profile values (Mongo / legacy M-F-X) to applicant dropdown values. */
export function canonicalApplicantSex(raw) {
  const t = String(raw ?? '').trim();
  if (!t || t === '—') return '';
  const s = t.toLowerCase();
  if (['m', 'masculino', 'male', 'hombre'].includes(s)) return 'male';
  if (['f', 'femenino', 'female', 'mujer'].includes(s)) return 'female';
  if (['x', 'undetermined', 'indeterminado', 'indeterminate'].includes(s)) return 'undetermined';
  return '';
}

export function labelForApplicantSex(raw) {
  const v = canonicalApplicantSex(raw);
  const row = APPLICANT_SEX_OPTIONS.find((o) => o.value === v);
  return row ? row.label : String(raw || '').trim() || '—';
}
